import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './App.css';

function UniversalHeader() {
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const isStaffDashboard = location.pathname === '/staff-dashboard';

  const goTo = (path) => {
    setOpen(false);
    if (location.pathname !== path) {
      navigate(path);
    }
  };

  return (
    <header className={`uh-root ${isStaffDashboard ? 'uh-root--staff' : ''}`}>
      <div className="uh-left">
        <span className="uh-app-name">
          {isStaffDashboard ? 'Staff workspace' : 'ODUS'}
        </span>
        <span className="uh-app-sub">
          {isStaffDashboard ? 'Maintenance navigation' : 'Navigation'}
        </span>
      </div>

      {!isStaffDashboard && (
        <div className="uh-right">
          <button
            type="button"
            className={`uh-toggle ${open ? 'uh-toggle--open' : ''}`}
            aria-label="Open navigation menu"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            <span />
            <span />
            <span />
          </button>

          {open && (
            <div className="uh-menu" role="menu">
              <button
                type="button"
                className="uh-menu-item"
                onClick={() => goTo('/dashboard')}
              >
                Dashboard
              </button>
              <button
                type="button"
                className="uh-menu-item"
                onClick={() => goTo('/properties')}
              >
                Properties
              </button>
              <button
                type="button"
                className="uh-menu-item"
                onClick={() => goTo('/tenants')}
              >
                Prospective tenants
              </button>
              <button
                type="button"
                className="uh-menu-item"
                onClick={() => goTo('/enquiries')}
              >
                Enquiries
              </button>
              <button
                type="button"
                className="uh-menu-item"
                onClick={() => goTo('/accounts')}
              >
                Accounts
              </button>
              <button
                type="button"
                className="uh-menu-item"
                onClick={() => goTo('/rent-management')}
              >
                Rent management
              </button>
              <button
                type="button"
                className="uh-menu-item"
                onClick={() => goTo('/maintenance')}
              >
                Maintenance
              </button>
              <button
                type="button"
                className="uh-menu-item"
                onClick={() => goTo('/maintenance-requests')}
              >
                Maintenance requests
              </button>
              <button
                type="button"
                className="uh-menu-item"
                onClick={() => goTo('/feedback')}
              >
                Feedback
              </button>
              <button
                type="button"
                className="uh-menu-item"
                onClick={() => goTo('/analytics')}
              >
                Analytics
              </button>
              <button
                type="button"
                className="uh-menu-item"
                onClick={() => goTo('/staff')}
              >
                Staff
              </button>
              <button
                type="button"
                className="uh-menu-item uh-menu-item--logout"
                onClick={() => goTo('/admin')}
              >
                Logout
              </button>
            </div>
          )}
        </div>
      )}
    </header>
  );
}

export default UniversalHeader;

